'use es6';

import PropTypes from 'prop-types';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { FilterEditProvider } from './components/FilterEditContext';
import { SourceMetaProvider, useSourceMeta } from './components/SourceMeta';
import BaseFilterEditor from './BaseFilterEditor';
import { FilterTypeContextProvider } from './components/FilterTypeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const Contents = ({
  onChange,
  onUpdateEventDateInterval
}) => {
  const sourceMeta = useSourceMeta();
  if (!sourceMeta) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return /*#__PURE__*/_jsx(FilterEditProvider, {
    sourceMeta: sourceMeta,
    onChange: onChange,
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "snowflake-filter-editor",
      children: /*#__PURE__*/_jsx(BaseFilterEditor, {
        mode: "edit",
        onChange: onChange,
        onUpdateEventDateInterval: onUpdateEventDateInterval
      })
    })
  });
};
const SnowflakeFilterEditor = ({
  schema = 'report',
  definition,
  onChange,
  onUpdateEventDateInterval,
  context = 'ROW_LEVEL'
}) => /*#__PURE__*/_jsx(SourceMetaProvider, {
  schema: schema,
  initialDefinition: definition,
  children: /*#__PURE__*/_jsx(FilterTypeContextProvider, {
    context: context,
    children: /*#__PURE__*/_jsx(Contents, {
      onChange: onChange,
      onUpdateEventDateInterval: onUpdateEventDateInterval
    })
  })
});
SnowflakeFilterEditor.propTypes = {
  schema: PropTypes.oneOf(['report', 'dataset']),
  definition: PropTypes.object,
  onChange: PropTypes.func,
  onUpdateEventDateInterval: PropTypes.func
};
export default SnowflakeFilterEditor;